/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 12:18 PM
 *
 */

import { MemberModal } from 'features/members/components/modal/MemberModal/MemberModal';

export default MemberModal;
